var map = {
	"./img/about-us/about-cafs-finance.svg": 62637,
	"./img/about-us/about-us-evolve-white1.png": 35982,
	"./img/about-us/about-us-evolve-white2.png": 47461,
	"./img/about-us/about-us-evolve-white3.png": 11548,
	"./img/about-us/about-us-evolve1.svg": 13170,
	"./img/about-us/about-us-evolve2.svg": 18209,
	"./img/about-us/about-us-evolve3.svg": 5968,
	"./img/about-us/about-us-header.png": 17047,
	"./img/about-us/about-us-header1.svg": 9386,
	"./img/about-us/about-us-header2.svg": 35385,
	"./img/about-us/arrow-about-banner-arrow.svg": 43159,
	"./img/about-us/cafs-arrow-orange.svg": 4475,
	"./img/about-us/mission-white.gif": 67648,
	"./img/about-us/vision-white.gif": 73602,
	"./img/careers/cafs-team-1.svg": 50201,
	"./img/careers/cafs-team-2.svg": 5802,
	"./img/careers/cafs-team-3.svg": 23643,
	"./img/careers/cafs-team-4.svg": 90580,
	"./img/careers/cafs-team-5.svg": 16213,
	"./img/careers/cafs-team-6.svg": 74966,
	"./img/careers/careers-form-bg.png": 45610,
	"./img/careers/careers-half-ring.png": 42514,
	"./img/careers/careers-office-members.png": 22756,
	"./img/careers/careers-two-rings.png": 39172,
	"./img/careers/contact-form-bg.png": 9943,
	"./img/careers/face-bg.png": 22247,
	"./img/careers/facebook.png": 72512,
	"./img/careers/instagram.png": 42826,
	"./img/careers/job-details-bg.png": 38444,
	"./img/careers/job_details_bg2.png": 63732,
	"./img/careers/linkedin.png": 62,
	"./img/careers/not-suitable-work-1.png": 29255,
	"./img/careers/not-suitable-work-2.png": 9196,
	"./img/careers/social-X-white.svg": 34052,
	"./img/careers/social-X.svg": 7108,
	"./img/careers/social-fb-white.svg": 48940,
	"./img/careers/social-fb.svg": 53820,
	"./img/careers/social-in-white.svg": 24461,
	"./img/careers/social-in.svg": 38057,
	"./img/careers/x.svg": 97314,
	"./img/careers/youtube.png": 75769,
	"./img/common/404.png": 70026,
	"./img/common/animated-arrow-white.gif": 50468,
	"./img/common/arrow-step-1.png": 23572,
	"./img/common/arrow-step-2.png": 98063,
	"./img/common/background-section.svg": 32998,
	"./img/common/bg-portfolio.png": 75610,
	"./img/common/cafs-logo-image.png": 67153,
	"./img/common/cafs-logo-mobile.png": 23946,
	"./img/common/cafs-logo-white.png": 94749,
	"./img/common/choosing-insurance-bg.png": 21921,
	"./img/common/claim-process-img.png": 76724,
	"./img/common/comman-icon-1.png": 99201,
	"./img/common/comman-icon-1white.png": 77594,
	"./img/common/comman-icon-2.png": 50218,
	"./img/common/comman-icon-2white.png": 5023,
	"./img/common/comman-icon-3.png": 979,
	"./img/common/comman-icon-3white.png": 27964,
	"./img/common/comman-icon-4.png": 17372,
	"./img/common/comman-icon-4white.png": 42233,
	"./img/common/corner-round-bg.png": 42350,
	"./img/common/document-age-proof.png": 19188,
	"./img/common/document-finding.png": 9167,
	"./img/common/document-id.png": 37629,
	"./img/common/document-kyc.png": 70151,
	"./img/common/document-location.png": 64139,
	"./img/common/document-medical.png": 49201,
	"./img/common/down-arrow.svg": 17228,
	"./img/common/download-gif.gif": 38382,
	"./img/common/error.gif": 12555,
	"./img/common/faq-remove-orange.svg": 16280,
	"./img/common/faq-remove-white.svg": 32873,
	"./img/common/faq1.svg": 63565,
	"./img/common/faq2.svg": 52846,
	"./img/common/header.png": 1279,
	"./img/common/health-banner.svg": 28765,
	"./img/common/health-insurance-banner.png": 98154,
	"./img/common/learn-banner-section-1.png": 44345,
	"./img/common/learn-banner-section-2.png": 30338,
	"./img/common/new-bg-1.png": 48160,
	"./img/common/photographs.png": 27341,
	"./img/common/prototype-banner.png": 41529,
	"./img/common/quote-faq.svg": 85575,
	"./img/common/related-health.png": 53140,
	"./img/common/related-mf.png": 45407,
	"./img/common/reviewer-li.png": 26397,
	"./img/common/reviewer-li2.png": 83355,
	"./img/common/reviewer-li3.png": 34354,
	"./img/common/right-arrow-animated.gif": 77199,
	"./img/common/sidebar-ad-1.gif": 78339,
	"./img/common/sidebar-ad-2.png": 5407,
	"./img/common/sidebar-ad-2.svg": 10319,
	"./img/common/sidebar-life-icon.svg": 9795,
	"./img/common/sidebar-mutual-fund-icon.svg": 41967,
	"./img/common/social-X-white.svg": 16978,
	"./img/common/social-X.svg": 38838,
	"./img/common/social-fb-white.svg": 46350,
	"./img/common/social-fb.svg": 25218,
	"./img/common/social-in-white.svg": 33955,
	"./img/common/social-in.svg": 9347,
	"./img/common/splash.gif": 16186,
	"./img/common/star-ratings.svg": 47345,
	"./img/common/talk-to-expert.png": 93789,
	"./img/common/u-turn-arrow.gif": 86988,
	"./img/contact-us/banglore.png": 98936,
	"./img/contact-us/chennai.png": 52876,
	"./img/contact-us/claim-card.svg": 42377,
	"./img/contact-us/claim-icon-orange.svg": 82731,
	"./img/contact-us/claim-icon-white.svg": 4900,
	"./img/contact-us/customer-care-white.svg": 83636,
	"./img/contact-us/karnataka-map.svg": 25195,
	"./img/contact-us/newpolicy-card.svg": 4321,
	"./img/contact-us/newpolicy-icon-orange.svg": 10547,
	"./img/contact-us/newpolicy-icon-white.svg": 91772,
	"./img/contact-us/pin.svg": 28451,
	"./img/contact-us/renewal-card.svg": 57253,
	"./img/contact-us/renewal-icon-orange.svg": 14511,
	"./img/contact-us/renewal-icon-white.svg": 65624,
	"./img/contact-us/tamilnadu-map.svg": 50440,
	"./img/contact-us/thanjavur.png": 88581,
	"./img/footer/bottom-curve.svg": 18945,
	"./img/header/Career-sub-menu.png": 59491,
	"./img/header/company/submenu-about-us-orange.svg": 60999,
	"./img/header/company/submenu-about-us.svg": 32912,
	"./img/header/company/submenu-careers-orange.svg": 67072,
	"./img/header/company/submenu-careers.svg": 86589,
	"./img/header/company/submenu-contact-us-orange.svg": 2544,
	"./img/header/company/submenu-contact-us.svg": 1709,
	"./img/header/learn/submenu-health-or.svg": 2431,
	"./img/header/learn/submenu-health.svg": 82911,
	"./img/header/learn/submenu-learn-nps-or.svg": 86195,
	"./img/header/learn/submenu-learn-nps.svg": 15419,
	"./img/header/learn/submenu-learn-stocks-or.svg": 10235,
	"./img/header/learn/submenu-learn-stocks.svg": 54451,
	"./img/header/learn/submenu-life-or.svg": 72019,
	"./img/header/learn/submenu-life.svg": 74363,
	"./img/header/products/submenu-health-family-or.svg": 60468,
	"./img/header/products/submenu-health-family.svg": 72726,
	"./img/header/products/submenu-health-group-or.svg": 35123,
	"./img/header/products/submenu-health-group.svg": 24859,
	"./img/header/products/submenu-health-individual.svg": 42411,
	"./img/header/products/submenu-health-or.svg": 97329,
	"./img/header/products/submenu-health.svg": 8613,
	"./img/header/products/submenu-individual-or.svg": 44208,
	"./img/header/products/submenu-life-or.svg": 91985,
	"./img/header/products/submenu-life-term-or.svg": 12894,
	"./img/header/products/submenu-life-term.svg": 47420,
	"./img/header/products/submenu-life-ulip.svg": 68442,
	"./img/header/products/submenu-life-wlip.svg": 77356,
	"./img/header/products/submenu-life.svg": 53509,
	"./img/header/products/submenu-ulip-or.svg": 63287,
	"./img/header/products/submenu-wlip-or.svg": 19521,
	"./img/header/service/service-menu-financial-consultant-orange.svg": 20684,
	"./img/header/service/service-menu-financial-consultant.svg": 60953,
	"./img/header/service/service-menu-investment-advice-orange.svg": 7315,
	"./img/header/service/service-menu-investment-advice.svg": 2892,
	"./img/header/service/service-menu-portfolio-management.svg": 99916,
	"./img/header/service/service-menu-portfolio_management-orange.svg": 2893,
	"./img/header/service/service-submenu-banner.png": 14020,
	"./img/header/service/submenu-how-to-invest-or.svg": 82176,
	"./img/header/service/submenu-how-to-invest.svg": 42650,
	"./img/header/submenu-fixed-deposit.png": 49861,
	"./img/header/submenu-mf.png": 9165,
	"./img/header/submenu-mi.png": 39930,
	"./img/home/Choice-of-investment.gif": 6732,
	"./img/home/Convenient-process.gif": 75134,
	"./img/home/Investment-analysis.gif": 40881,
	"./img/home/cafs-circle-text.svg": 97860,
	"./img/home/cafs-process-mbl.png": 47939,
	"./img/home/family-group.svg": 70676,
	"./img/home/financial-consultant-icon.svg": 34259,
	"./img/home/fixed-deposit.gif": 56384,
	"./img/home/health-insurance.gif": 42740,
	"./img/home/home-banner-right-arrow.svg": 90115,
	"./img/home/home_left_box.svg": 76083,
	"./img/home/how-to-invest.svg": 59928,
	"./img/home/intro-aim.gif": 70545,
	"./img/home/investment-advice-icon.svg": 99204,
	"./img/home/life-insurance.gif": 16856,
	"./img/home/motor-insurance.gif": 28119,
	"./img/home/mutual-fund.gif": 60451,
	"./img/home/nps.gif": 65066,
	"./img/home/portfolio-management-icon.svg": 72360,
	"./img/home/stocks.gif": 19956,
	"./img/home/why-choose-cafs_bg.svg": 47120,
	"./img/icons/check-circle.svg": 86670,
	"./img/learn/health-insurance/cashless-claim-benefit.png": 3038,
	"./img/learn/health-insurance/coverage-for-critical-illness.png": 38580,
	"./img/learn/health-insurance/extra-coverage-facility.png": 4396,
	"./img/learn/health-insurance/health-banner.svg": 57506,
	"./img/learn/health-insurance/health-benefits-common.png": 28602,
	"./img/learn/health-insurance/health-cashless-claim.png": 2883,
	"./img/learn/health-insurance/health-claim-expected-event.png": 34292,
	"./img/learn/health-insurance/health-emergency-claim.png": 92956,
	"./img/learn/health-insurance/health-human-individual.svg": 43773,
	"./img/learn/health-insurance/health-human-parents.svg": 53047,
	"./img/learn/health-insurance/health-human-senior-citizen.svg": 44671,
	"./img/learn/health-insurance/health-human-spouse.svg": 92961,
	"./img/learn/health-insurance/health-overview.png": 35903,
	"./img/learn/health-insurance/individual-point1.svg": 29882,
	"./img/learn/health-insurance/individual-point2.svg": 74697,
	"./img/learn/health-insurance/individual-point3.svg": 49336,
	"./img/learn/health-insurance/individual-point4.svg": 94263,
	"./img/learn/health-insurance/individual-spring.png": 4984,
	"./img/learn/health-insurance/medical-expenses.png": 34620,
	"./img/learn/life-insurance/child-plan.png": 60207,
	"./img/learn/life-insurance/choose-life-insurance-bg.png": 78330,
	"./img/learn/life-insurance/employee-white.svg": 84741,
	"./img/learn/life-insurance/endowment-plans.png": 12599,
	"./img/learn/life-insurance/evolve-icon1.svg": 44849,
	"./img/learn/life-insurance/evolve-icon2.svg": 90306,
	"./img/learn/life-insurance/evolve-icon3.svg": 52947,
	"./img/learn/life-insurance/evolve-white1.png": 16689,
	"./img/learn/life-insurance/evolve-white2.png": 86522,
	"./img/learn/life-insurance/evolve-white3.png": 87747,
	"./img/learn/life-insurance/evolve-white4.png": 57580,
	"./img/learn/life-insurance/insurance-works.png": 99168,
	"./img/learn/life-insurance/life-importance-bg.png": 12250,
	"./img/learn/life-insurance/life-insurance-section1.png": 68829,
	"./img/learn/life-insurance/money-back-plan.png": 55897,
	"./img/learn/life-insurance/retirement-plans.png": 78155,
	"./img/learn/life-insurance/term-insurance.png": 25020,
	"./img/learn/life-insurance/ulip.png": 1521,
	"./img/learn/life-insurance/wlip.png": 12327,
	"./img/logo/cafs-fav-icon.svg": 29339,
	"./img/logo/cafs-logo-blue.svg": 46418,
	"./img/logo/cafs-logo-white.svg": 16985,
	"./img/mutual-fund/mf-best-returns.svg": 69689,
	"./img/mutual-fund/mf-index.svg": 4047,
	"./img/mutual-fund/mf-instant-redemption.svg": 83542,
	"./img/mutual-fund/mf-sip.svg": 20591,
	"./img/mutual-fund/mf-tax-saving.svg": 92071,
	"./img/mutual-fund/mf-top-rated.svg": 43063,
	"./img/mutual-fund/mutual-fund.png": 46603,
	"./img/nps/nps-home.png": 65703,
	"./img/nps/what-is-nps.png": 49859,
	"./img/products/amc/360.png": 65628,
	"./img/products/amc/aditya-birla.png": 23950,
	"./img/products/amc/angel-one.png": 70913,
	"./img/products/amc/aviva-life.png": 42429,
	"./img/products/amc/axis.png": 17470,
	"./img/products/amc/bajaj.png": 9223,
	"./img/products/amc/bandhan.png": 27003,
	"./img/products/amc/baroda-bnp.png": 51313,
	"./img/products/amc/boi.png": 30271,
	"./img/products/amc/canara-robeco.png": 34632,
	"./img/products/amc/care-health.png": 95323,
	"./img/products/amc/dsp.png": 45576,
	"./img/products/amc/edelweiss.png": 54698,
	"./img/products/amc/franklin-templeton.png": 13973,
	"./img/products/amc/grow.png": 60372,
	"./img/products/amc/hdfc-health.png": 87829,
	"./img/products/amc/hdfc-life.png": 46177,
	"./img/products/amc/hdfc.png": 2096,
	"./img/products/amc/helios.png": 10687,
	"./img/products/amc/hsbc.png": 50535,
	"./img/products/amc/icici.png": 49760,
	"./img/products/amc/idbi.png": 18765,
	"./img/products/amc/indiafirst-life.png": 31697,
	"./img/products/amc/invesco.png": 32510,
	"./img/products/amc/iti.png": 49053,
	"./img/products/amc/jm.png": 46542,
	"./img/products/amc/kotak.png": 12939,
	"./img/products/amc/l&t.png": 63171,
	"./img/products/amc/lic.png": 75785,
	"./img/products/amc/mahindra-manulife.png": 15349,
	"./img/products/amc/mirae-asset.png": 6932,
	"./img/products/amc/motilal.png": 42841,
	"./img/products/amc/navi.png": 61809,
	"./img/products/amc/nippon-india.png": 82831,
	"./img/products/amc/niva-health.png": 63858,
	"./img/products/amc/nj.png": 80077,
	"./img/products/amc/old-bridge.png": 55262,
	"./img/products/amc/pgim.png": 8216,
	"./img/products/amc/ppfas.png": 48287,
	"./img/products/amc/quant.png": 53508,
	"./img/products/amc/quantum.png": 53054,
	"./img/products/amc/sahara.png": 62491,
	"./img/products/amc/samco.png": 30714,
	"./img/products/amc/sbi.png": 9361,
	"./img/products/amc/shriram.png": 39787,
	"./img/products/amc/star-health.png": 3462,
	"./img/products/amc/sundaram.png": 66688,
	"./img/products/amc/tata-health.png": 14182,
	"./img/products/amc/tata-life.png": 19638,
	"./img/products/amc/tata.png": 26541,
	"./img/products/amc/taurus.png": 52069,
	"./img/products/amc/trust.png": 3475,
	"./img/products/amc/union.png": 16072,
	"./img/products/amc/uti.png": 40417,
	"./img/products/amc/whiteoak.png": 5083,
	"./img/products/common/download-gif.gif": 63861,
	"./img/products/company/apollo-munich.svg": 20609,
	"./img/products/company/aviva-life.png": 73945,
	"./img/products/company/bajaj allianz-mbl.svg": 91574,
	"./img/products/company/bajaj-life.png": 10732,
	"./img/products/company/care-health.png": 70007,
	"./img/products/company/care-mbl.svg": 92574,
	"./img/products/company/hdfc-health.png": 85305,
	"./img/products/company/hdfc-life-mbl.svg": 38815,
	"./img/products/company/hdfc-life.png": 15861,
	"./img/products/company/hdfc-mbl.svg": 49164,
	"./img/products/company/icici-life.png": 90333,
	"./img/products/company/icici-mbl.svg": 37162,
	"./img/products/company/indiafirst-life-mbl.svg": 71751,
	"./img/products/company/indiafirst-life.png": 2677,
	"./img/products/company/kotak.svg": 44641,
	"./img/products/company/lic.svg": 54891,
	"./img/products/company/niva-health-mbl.svg": 37144,
	"./img/products/company/niva-health.png": 29862,
	"./img/products/company/sbi-mutual-fund.svg": 8704,
	"./img/products/company/shriram-icon.svg": 85977,
	"./img/products/company/star-health.png": 33650,
	"./img/products/company/star-health.svg": 86584,
	"./img/products/company/star-mbl.svg": 18145,
	"./img/products/company/tata-aia-life.png": 16602,
	"./img/products/company/tata-aia-mbl.svg": 73549,
	"./img/products/company/tata-aig-mbl.svg": 54007,
	"./img/products/company/tata-health.png": 14698,
	"./img/products/company/tata-life.png": 80330,
	"./img/products/family-insurance/family-benefit1.png": 71980,
	"./img/products/family-insurance/family-benefit2.png": 22663,
	"./img/products/family-insurance/family-benefit3.png": 46878,
	"./img/products/family-insurance/family-benefit4.png": 91441,
	"./img/products/family-insurance/family-benefit5.png": 43048,
	"./img/products/family-insurance/family-benefit6.png": 5027,
	"./img/products/family-insurance/family-benefit7.png": 15194,
	"./img/products/family-insurance/family-benefit8.png": 84429,
	"./img/products/family-insurance/family-intro1.png": 68793,
	"./img/products/family-insurance/family-intro2.png": 4258,
	"./img/products/family-insurance/family-intro3.png": 41739,
	"./img/products/fixed-deposit/fd-banner.png": 87378,
	"./img/products/fixed-deposit/fd-benefit-compound-interest.svg": 84782,
	"./img/products/fixed-deposit/fd-benefit-easy-manage.svg": 93110,
	"./img/products/fixed-deposit/fd-benefit-market-risk.svg": 87112,
	"./img/products/fixed-deposit/fd-benefit-stability.svg": 26833,
	"./img/products/fixed-deposit/fd-intro.png": 35132,
	"./img/products/fixed-deposit/fd-key-features-effortless.png": 11047,
	"./img/products/fixed-deposit/fd-key-features-extra-benefit-senier.png": 59701,
	"./img/products/fixed-deposit/fd-key-features-fixed-returns.png": 69988,
	"./img/products/fixed-deposit/fd-key-features-risk-free.png": 9916,
	"./img/products/group-insurance/added-health-benefits.svg": 41350,
	"./img/products/group-insurance/ancillary-expenses.svg": 5633,
	"./img/products/group-insurance/cashless-treatment.svg": 62029,
	"./img/products/group-insurance/cost-effective-protection.svg": 32609,
	"./img/products/group-insurance/group-intro1.png": 25797,
	"./img/products/group-insurance/group-intro2.png": 7022,
	"./img/products/group-insurance/group-intro3.png": 97015,
	"./img/products/group-insurance/group-key-reason1.png": 6915,
	"./img/products/group-insurance/group-key-reason2.png": 28584,
	"./img/products/group-insurance/group-key-reason3.png": 76977,
	"./img/products/group-insurance/group-key-reason4.png": 32414,
	"./img/products/group-insurance/hospitalization-coverage.svg": 14869,
	"./img/products/group-insurance/no-medical-screening.svg": 45156,
	"./img/products/health-insurance/aditya-birla-health.png": 91083,
	"./img/products/health-insurance/bajaj-health.png": 58448,
	"./img/products/health-insurance/care-health.png": 44951,
	"./img/products/health-insurance/digit-health.png": 24227,
	"./img/products/health-insurance/galaxy-health.png": 99278,
	"./img/products/health-insurance/hdfc-health.png": 61625,
	"./img/products/health-insurance/health-intro-growth-rate.png": 88789,
	"./img/products/health-insurance/health-intro-left.png": 39010,
	"./img/products/health-insurance/health-type1.png": 6921,
	"./img/products/health-insurance/health-type10.png": 11533,
	"./img/products/health-insurance/health-type2.png": 92306,
	"./img/products/health-insurance/health-type3.png": 7131,
	"./img/products/health-insurance/health-type4.png": 43268,
	"./img/products/health-insurance/health-type5.png": 97165,
	"./img/products/health-insurance/health-type6.png": 66838,
	"./img/products/health-insurance/health-type7.png": 80127,
	"./img/products/health-insurance/health-type8.png": 50280,
	"./img/products/health-insurance/health-type9.png": 44145,
	"./img/products/health-insurance/icici-lombard-health.png": 74575,
	"./img/products/health-insurance/insurance-benefit-white.svg": 15587,
	"./img/products/health-insurance/insurance-benefit.png": 98479,
	"./img/products/health-insurance/insurance-person-white.svg": 82185,
	"./img/products/health-insurance/insurance-person.png": 60803,
	"./img/products/health-insurance/insurance-search-white.svg": 47226,
	"./img/products/health-insurance/insurance-search.png": 43032,
	"./img/products/health-insurance/insurance-support-white.svg": 43603,
	"./img/products/health-insurance/insurance-support.png": 92835,
	"./img/products/health-insurance/li-intro-quote.png": 81686,
	"./img/products/health-insurance/niva-health.png": 24102,
	"./img/products/health-insurance/sbi-health.png": 15998,
	"./img/products/health-insurance/star-health.png": 61618,
	"./img/products/health-insurance/tata-health.png": 70282,
	"./img/products/health-insurance/what-health-insurance.png": 74719,
	"./img/products/individual-insurance/individual-change.png": 93136,
	"./img/products/individual-insurance/individual-intro1.png": 54167,
	"./img/products/individual-insurance/individual-intro2.png": 65436,
	"./img/products/individual-insurance/individual-intro3.png": 82949,
	"./img/products/individual-insurance/pro-highlight-1.png": 53090,
	"./img/products/individual-insurance/pro-highlight-2.png": 1273,
	"./img/products/individual-insurance/pro-highlight-3.png": 4368,
	"./img/products/individual-insurance/pro-highlight-4.png": 47215,
	"./img/products/individual-insurance/pro-highlight-5.png": 8198,
	"./img/products/individual-insurance/pro-highlight-6.png": 49437,
	"./img/products/individual-insurance/pro-highlight-7.png": 28308,
	"./img/products/individual-insurance/pro-highlight-8.png": 54227,
	"./img/products/life-insurance/aditya-life.png": 40176,
	"./img/products/life-insurance/aviva-life.png": 76489,
	"./img/products/life-insurance/axis-life.png": 46219,
	"./img/products/life-insurance/bajaj-life.png": 91996,
	"./img/products/life-insurance/bandhan-life.png": 84096,
	"./img/products/life-insurance/benefits-of-life-insurance.png": 99951,
	"./img/products/life-insurance/edelwesis-life.png": 73583,
	"./img/products/life-insurance/hdfc-life.png": 33029,
	"./img/products/life-insurance/icici-life.png": 30285,
	"./img/products/life-insurance/impartance-bg.png": 97053,
	"./img/products/life-insurance/indiafirst-life.png": 64069,
	"./img/products/life-insurance/kotak-life.png": 86616,
	"./img/products/life-insurance/li-intro-growth-rate.png": 57882,
	"./img/products/life-insurance/li-intro-quote.png": 65126,
	"./img/products/life-insurance/li-intro.png": 89221,
	"./img/products/life-insurance/life-banner.png": 52308,
	"./img/products/life-insurance/life-insurance-section1.png": 39941,
	"./img/products/life-insurance/max-life.png": 60772,
	"./img/products/life-insurance/sbi-life.png": 31438,
	"./img/products/life-insurance/tata-aia-life.png": 20522,
	"./img/products/life-insurance/tata-life.png": 71514,
	"./img/products/life-insurance/types-insurence-1.png": 25643,
	"./img/products/life-insurance/types-insurence-2.png": 60240,
	"./img/products/life-insurance/types-insurence-3.png": 75993,
	"./img/products/life-insurance/types-insurence-4.png": 87366,
	"./img/products/life-insurance/types-insurence-5.png": 72463,
	"./img/products/life-insurance/types-insurence-6.png": 50004,
	"./img/products/life-insurance/types-insurence-7.png": 71133,
	"./img/products/motor-insurance/addon-benefits.svg": 321,
	"./img/products/motor-insurance/bike.svg": 79877,
	"./img/products/motor-insurance/car-driver.svg": 46643,
	"./img/products/motor-insurance/car.svg": 18260,
	"./img/products/motor-insurance/cashless-repair.svg": 23898,
	"./img/products/motor-insurance/damage-coverage.svg": 21652,
	"./img/products/motor-insurance/handshake.svg": 65977,
	"./img/products/motor-insurance/instant-policy-isuance.svg": 10883,
	"./img/products/motor-insurance/intro-man.png": 87657,
	"./img/products/motor-insurance/liabiity-protection.svg": 15107,
	"./img/products/motor-insurance/personal-cover.svg": 26704,
	"./img/products/product-calander.png": 75705,
	"./img/products/product-danger.png": 88714,
	"./img/products/product-form.png": 94697,
	"./img/products/product-nofile.png": 28472,
	"./img/products/product-pie.png": 36517,
	"./img/products/product-pigbank.png": 96733,
	"./img/products/product-tag.png": 13803,
	"./img/products/term-insurance/term-accident.png": 73889,
	"./img/products/term-insurance/term-affortable.png": 14344,
	"./img/products/term-insurance/term-ambulance.gif": 44625,
	"./img/products/term-insurance/term-cost.png": 33853,
	"./img/products/term-insurance/term-critical.png": 41317,
	"./img/products/term-insurance/term-customise.png": 90758,
	"./img/products/term-insurance/term-death.png": 54326,
	"./img/products/term-insurance/term-family.png": 62250,
	"./img/products/term-insurance/term-house-img.png": 26166,
	"./img/products/term-insurance/term-house.gif": 17827,
	"./img/products/term-insurance/term-insurance-best.png": 69377,
	"./img/products/term-insurance/term-insurance-premium.png": 88664,
	"./img/products/term-insurance/term-list1.png": 61801,
	"./img/products/term-insurance/term-list2.png": 96658,
	"./img/products/term-insurance/term-list3.png": 62011,
	"./img/products/term-insurance/term-list4.png": 52068,
	"./img/products/term-insurance/term-person.gif": 80726,
	"./img/products/term-insurance/term-rider.png": 24840,
	"./img/products/term-insurance/term-taxbenefit.png": 19834,
	"./img/products/ulip-point1.png": 48375,
	"./img/products/ulip-point2.png": 59644,
	"./img/products/ulip-point3.png": 77157,
	"./img/products/ulip/ulip-bank.gif": 38908,
	"./img/products/ulip/ulip-family.png": 16121,
	"./img/products/ulip/ulip-heart.gif": 77350,
	"./img/products/ulip/ulip-point1.png": 94638,
	"./img/products/ulip/ulip-point2.png": 22469,
	"./img/products/ulip/ulip-point3.png": 70204,
	"./img/products/ulip/ulip-time.gif": 68465,
	"./img/products/view-product-triangle.png": 78623,
	"./img/products/whole-life/types-of-whole-life-insurance.png": 27519,
	"./img/products/whole-life/wlip-bank.gif": 23110,
	"./img/products/whole-life/wlip-person.gif": 22963,
	"./img/products/whole-life/wlip-type1.png": 63314,
	"./img/products/whole-life/wlip-type2.png": 77929,
	"./img/products/whole-life/wlip-type3.png": 99808,
	"./img/products/whole-life/wlip-type4.png": 51135,
	"./img/products/whole-life/wlip-type5.png": 37846,
	"./img/products/whole-life/wlip-type6.png": 68173,
	"./img/products/whole-life/wlip-wheelchair.gif": 84664,
	"./img/reviewers/fem-2.png": 17026,
	"./img/reviewers/fem-3.png": 38155,
	"./img/reviewers/fem-4.png": 88244,
	"./img/reviewers/men-1.png": 4585,
	"./img/reviewers/men-3.png": 77947,
	"./img/reviewers/men-4.png": 23140,
	"./img/services/financial-consultant/fiancial-advisors-make-money-fixedfee.svg": 49147,
	"./img/services/financial-consultant/fiancial-advisors-make-money-percentage.svg": 1869,
	"./img/services/financial-consultant/fiancial-advisors_make-money-commision.svg": 77547,
	"./img/services/financial-consultant/financial-advisor1.svg": 7280,
	"./img/services/financial-consultant/financial-advisor2.svg": 64323,
	"./img/services/financial-consultant/financial-advisor3.svg": 49682,
	"./img/services/financial-consultant/financial-consultant-do.png": 71040,
	"./img/services/financial-consultant/financial-consultant-intro.png": 95045,
	"./img/services/financial-consultant/qualify-contestant-cost.svg": 72232,
	"./img/services/financial-consultant/qualify-contestant-education.svg": 77631,
	"./img/services/financial-consultant/qualify-contestant-experience.svg": 53939,
	"./img/services/financial-consultant/qualify-contestant-researchskill.svg": 85643,
	"./img/services/financial-consultant/what-is-financial-consultant.png": 63164,
	"./img/services/how-to-invest/Basics-investment-left.png": 47877,
	"./img/services/how-to-invest/Basics-investment-right.png": 14662,
	"./img/services/how-to-invest/accumulated.png": 43604,
	"./img/services/how-to-invest/analysis-techniques.svg": 18782,
	"./img/services/how-to-invest/annualised.png": 19318,
	"./img/services/how-to-invest/arrow.svg": 11503,
	"./img/services/how-to-invest/average.png": 33747,
	"./img/services/how-to-invest/investment-option-gold.svg": 20922,
	"./img/services/how-to-invest/investment-option-health-insurance.svg": 95937,
	"./img/services/how-to-invest/investment-option-life-insurance.svg": 57765,
	"./img/services/how-to-invest/investment-option-real-estate.svg": 61533,
	"./img/services/how-to-invest/investment-option-stocks.svg": 46669,
	"./img/services/how-to-invest/investment-trends-crypto.png": 24742,
	"./img/services/how-to-invest/investment-trends-gold.png": 5171,
	"./img/services/how-to-invest/investment-trends-mutual-fund.png": 11621,
	"./img/services/how-to-invest/investment-trends-others.png": 23536,
	"./img/services/how-to-invest/investment-trends-sharemarket.png": 72116,
	"./img/services/how-to-invest/price.png": 77493,
	"./img/services/how-to-invest/return.png": 87974,
	"./img/services/how-to-invest/service-intro-howtoinvest.png": 45063,
	"./img/services/investment-advice/advisors.svg": 80149,
	"./img/services/investment-advice/commission-based.svg": 35499,
	"./img/services/investment-advice/consultants.svg": 91100,
	"./img/services/investment-advice/definition-investment-advice.png": 99082,
	"./img/services/investment-advice/fee-based.svg": 25908,
	"./img/services/investment-advice/investment-advice.png": 81984,
	"./img/services/investment-advice/source-investment-advice.png": 36706,
	"./img/services/investment-advice/when-to-seek-financial-advice.png": 10518,
	"./img/services/investment-advice/who-give-investment-advice.png": 42503,
	"./img/services/investment-advice/why-get-financial-advice.png": 78566,
	"./img/services/portfolio-management/importance-of-portfolio-management.png": 88687,
	"./img/services/portfolio-management/portfolio-management-active-management.png": 68315,
	"./img/services/portfolio-management/portfolio-management-avantages-balance.svg": 8144,
	"./img/services/portfolio-management/portfolio-management-avantages-desciplinedManners.svg": 23880,
	"./img/services/portfolio-management/portfolio-management-avantages-financial-understanding.svg": 36820,
	"./img/services/portfolio-management/portfolio-management-avantages-manage-liquidity.svg": 71118,
	"./img/services/portfolio-management/portfolio-management-avantages-readjust-investment.svg": 14760,
	"./img/services/portfolio-management/portfolio-management-avantages-right-investment.svg": 49928,
	"./img/services/portfolio-management/portfolio-management-avantages-track-performance.svg": 17644,
	"./img/services/portfolio-management/portfolio-management-components-effective-diversivication.png": 80267,
	"./img/services/portfolio-management/portfolio-management-cost-efficiency.png": 31982,
	"./img/services/portfolio-management/portfolio-management-intro.png": 63823,
	"./img/services/portfolio-management/portfolio-management-process-execution.png": 22703,
	"./img/services/portfolio-management/portfolio-management-process-feedback.png": 98676,
	"./img/services/portfolio-management/portfolio-management-process-planning.png": 44190,
	"./img/services/portfolio-management/portfolio-management-tax-efficiency.png": 53678,
	"./img/services/portfolio-management/portfolio-management.png": 8594,
	"./img/services/portfolio-management/right-arrow-animated.gif": 27905,
	"./img/services/portfolio-management/u-turn-arrow.gif": 12458,
	"./img/services/portfolio-management/who-is-portfolio-manager.png": 16422,
	"./img/stocks/buy-stocks.svg": 75938,
	"./img/stocks/investing-in-stocks-research.svg": 96295,
	"./img/stocks/investing-stock.svg": 99238,
	"./img/stocks/select-broker-platform.svg": 552,
	"./img/stocks/stocks-banner.png": 44888,
	"./img/stocks/stocks-open-demat.svg": 81622,
	"./img/stocks/types-of-stocks.png": 58561,
	"./img/stocks/what-is-stocks.png": 25787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73369;